<div class="simple-player-container">
  <!-- Video Background Layer -->
  <video
    class="video-tag"
    id="videoPlayer"
    #videoPlayer
    playsinline
    webkit-playsinline
    x-webkit-airplay="allow"
    preload="auto"
  ></video>

  <img
    #image
    fetchpriority="high"
    class="video-img"
    [class.animate]="shouldAnimate"
    [alt]="'image'"
    (load)="onImageLoad()"
    (error)="onImageError($event)"
    height="100%"
    min-height="30vw"
    [style.object-fit]="'cover'"
    [style.display]="showImage ? 'block' : 'none'"
  />

  <div class="gradient-overlay"></div>
</div>
